<!-- Se abre en un modal desde la ficha del cliente, que ya pone el título -->
<div>
  <app-page-header
    [className]="'mb-3!'"
    [showCreateButton]="permissionAuth.canCreate('clientes')"
    [textButton]="'Nuevo contrato'"
    (onCreateClick)="openCreateModal()"
  />

  <!-- Contrato Activo Destacado -->
  @if (contratoActivo) {
    <div class="mb-6 p-5 bg-green-50 border border-green-200 rounded-2xl dark:border-green-800 dark:bg-green-900/20">
      @if (contratoActivo.vencido) {
        <div class="mb-4 flex items-center gap-2 rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-sm text-error-700 dark:border-error-800 dark:bg-error-900/20 dark:text-error-300">
          <mat-icon class="text-base!">warning</mat-icon>
          <span>Contrato vencido{{ contratoActivo.fecha_fin ? ' el ' + (contratoActivo.fecha_fin | date: 'dd/MM/yyyy') : '' }}.</span>
        </div>
      }
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
          Contrato Activo
        </h3>
        <app-badge [color]="'success'" [startIcon]="'check_circle'">
          Activo
        </app-badge>
      </div>
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
        <div>
          <p class="mb-1 text-xs text-gray-500 dark:text-gray-400">Número</p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ contratoActivo.nro_contrato || ('Contrato #' + contratoActivo.id) }}
          </p>
        </div>
        <div>
          <p class="mb-1 text-xs text-gray-500 dark:text-gray-400">Fecha de inicio</p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ contratoActivo.fecha_inicio ? (contratoActivo.fecha_inicio | date: 'dd/MM/yyyy') : 'Sin fecha' }}
          </p>
        </div>
        <div>
          <p class="mb-1 text-xs text-gray-500 dark:text-gray-400">Fecha de fin</p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ contratoActivo.fecha_fin ? (contratoActivo.fecha_fin | date: 'dd/MM/yyyy') : 'Sin fecha' }}
          </p>
        </div>
        @if (contratoActivo.establecimiento) {
          <div>
            <p class="mb-1 text-xs text-gray-500 dark:text-gray-400">Establecimiento</p>
            <p class="text-sm font-medium text-gray-800 dark:text-white/90">
              {{ contratoActivo.establecimiento.nombre }}
            </p>
          </div>
        }
      </div>
      @if (contratoActivo.objetivos && contratoActivo.objetivos.length > 0) {
        <div class="mt-4 pt-4 border-t border-green-200 dark:border-green-800">
          <p class="mb-2 text-xs text-gray-500 dark:text-gray-400">Objetivos asociados: {{ contratoActivo.objetivos.length }}</p>
        </div>
      }
      @if (contratoActivo.documento) {
        <div class="mt-4 flex items-center justify-between border-t border-green-200 pt-4 dark:border-green-800">
          <span class="flex min-w-0 items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
            <mat-icon class="text-gray-400">description</mat-icon>
            <span class="truncate">{{ contratoActivo.documento.nombre }}</span>
          </span>
          <button
            type="button"
            class="ml-3 flex shrink-0 items-center gap-1 text-sm text-brand-500 hover:text-brand-700"
            (click)="descargarDocumento(contratoActivo, $event)"
          >
            <mat-icon class="text-base!">download</mat-icon>
            Descargar
          </button>
        </div>
      }
    </div>
  }

  <!-- Filtros -->
  <app-filters-container
    [hasData]="contratos.length > 0"
    [hasActiveFilters]="hasActiveFilters"
    [loading]="loading"
    (clearFilters)="clearFilters()"
  >
    <app-search-input
      label="Buscar"
      placeholder="Buscar por número o descripción..."
      [value]="filtros.busqueda"
      (searchChange)="onSearchChange($event)"
    />

    <app-filter-select
      label="Estado"
      [value]="filtros.activo"
      [options]="estadoOptions"
      (valueChange)="onEstadoChange($event)"
    />

    <app-filter-date
      label="Fecha inicio desde"
      [value]="filtros.fecha_desde"
      (valueChange)="onFechaDesdeChange($event)"
    />

    <app-filter-date
      label="Fecha inicio hasta"
      [value]="filtros.fecha_hasta"
      (valueChange)="onFechaHastaChange($event)"
    />
  </app-filters-container>

  <!-- Tabla -->
  <app-data-table
    [columns]="columns"
    [data]="contratos"
    [loading]="loading"
    [emptyTitle]="'No hay contratos registrados'"
    [emptySubtitle]="'Prueba ajustando los filtros o crea un nuevo contrato'"
    (rowClick)="onRowClick($event)"
  >
    <!-- Número de Contrato -->
    <ng-template appTableCell="nro_contrato" let-contrato>
      {{ contrato.nro_contrato || ('Contrato #' + contrato.id) }}
    </ng-template>

    <!-- Fecha Inicio -->
    <ng-template appTableCell="fecha_inicio" let-contrato>
      {{ contrato.fecha_inicio ? (contrato.fecha_inicio | date: 'dd/MM/yyyy') : 'Sin fecha' }}
    </ng-template>

    <!-- Fecha Fin -->
    <ng-template appTableCell="fecha_fin" let-contrato>
      @if (contrato.fecha_fin) {
        <!-- Issue #28: la fecha de un contrato cerrado no se pinta de rojo. -->
        <span [class.text-error-500]="contrato.activo && contrato.vencido">
          {{ contrato.fecha_fin | date: 'dd/MM/yyyy' }}
        </span>
      } @else {
        <span class="text-gray-400 dark:text-gray-500">Sin fecha</span>
      }
    </ng-template>

    <!-- Establecimiento -->
    <ng-template appTableCell="establecimiento" let-contrato>
      @if (contrato.establecimiento) {
        {{ contrato.establecimiento.nombre }}
      } @else {
        <span class="text-gray-400 dark:text-gray-500">-</span>
      }
    </ng-template>

    <!-- Estado -->
    <ng-template appTableCell="estado" let-contrato>
      <!--
        Issue #28 (2026-09-15): se pregunta por el cierre antes que por la fecha. Al
        revés, un contrato cerrado a mano con fecha_fin ya cumplida se mostraba como
        "Vencido" — `contrato.vencido` mira solo la fecha, no el estado.
      -->
      @if (!contrato.activo) {
        <app-badge [color]="'light'" [startIcon]="'cancel'">
          Cerrado
        </app-badge>
      } @else if (contrato.vencido) {
        <app-badge [color]="'error'" [startIcon]="'warning'">
          Vencido
        </app-badge>
      } @else {
        <app-badge [color]="'success'" [startIcon]="'check_circle'">
          Activo
        </app-badge>
      }
    </ng-template>

    <!-- Acciones -->
    <ng-template appTableCell="acciones" let-contrato let-index="index">
      <div class="flex items-center gap-x-2.5">
        @if (contrato.documento) {
          <button
            type="button"
            [disabled]="downloadingDocumentId === contrato.id"
            (click)="descargarDocumento(contrato, $event)"
            [matTooltip]="'Descargar documento'"
          >
            <mat-icon class="dark:text-gray-400!">download</mat-icon>
          </button>
        }

        <button
          (click)="openEditModal(contrato); $event.stopPropagation()"
          [matTooltip]="'Editar contrato'"
        >
          <mat-icon class="dark:text-gray-400!">edit</mat-icon>
        </button>

        <button
          (click)="toggleActivo(contrato, $event)"
          [matTooltip]="contrato.activo ? 'Cerrar contrato' : 'Activar contrato'"
        >
          <mat-icon class="dark:text-gray-400!">
            {{ contrato.activo ? 'toggle_on' : 'toggle_off' }}
          </mat-icon>
        </button>

          <app-delete-trigger *hasPermission="'clientes.registros:delete'"
            [title]="'Eliminar contrato'"
            [disabled]="deleting && (index === deletingIndex)"
            (clickDeleteEvent)="delete(contrato.id, index)"
          />
      </div>
    </ng-template>
  </app-data-table>

  <!-- Paginación -->
  <app-pagination
    [currentPage]="currentPage"
    [lastPage]="lastPage"
    [perPage]="perPage"
    [total]="total"
    (pageChange)="onPageChange($event)"
    (perPageChange)="onPerPageChange($event)"
  />
</div>
